import { useContext } from 'react';
import {
  CurrentUserInfoContext,
  ICurrentUserInfoContext,
} from '../contexts/CurrentUserInfoContext';

export const useCurrentUserInfo = (): ICurrentUserInfoContext => {
  const context = useContext(CurrentUserInfoContext);

  return context;
};
